<template>
  <div ref="rootRef" class="dropdown" :class="[menuAlignment, { show: isOpen }]">
    <ButtonElement
      class="btn--ms btn--neutral btn--regular btn-dropdown btn-large"
      id="dropdownMenuButton"
      :aria-expanded="isOpen"
      style="display: flex; align-items: center;justify-content: space-between"
      @click="toggle"
    >
        <div :style="`display: flex; align-items: center;justify-content: ${onlyIcon ? 'center' : 'flex-start'};gap: var(--spac-8);width: 100%;`">
          <LucideIcon v-if="icon" :icon="icon" />
          {{ name }}
        </div>
        <ChevronDown v-if="arrow && !onlyIcon" class="icon-angle" aria-hidden="true" />
    </ButtonElement>

    <ul class="dropdown-menu" :class="{ show: isOpen }" id="dropdownMenu" @click.stop="">
      <div class="dropdown-menu-box animation">
        <div class="dropdown-menu-head">
          <div class="title">{{ title }}</div>
          <div v-if="reset" class="button">
            <ButtonElement class="btn-link" @click="resetFilter()">
              Reset
            </ButtonElement>
          </div>
        </div>
        <li v-for="(option, index) in options" :key="index">
          <a @click="onOptionSelect($event, option)" class="dropdown-item">
            <div class="content">
              <CheckboxElement :name="option.name" :label="option.name" :model-value="isSelected(option)"
                class="w-100" />
            </div>
          </a>
        </li>
      </div>
    </ul>

  </div>
</template>

<script setup lang="ts">
import { ChevronDown } from '@lucide/vue'
import type {DropdownNs} from '@shared/types';
import {useDropdown} from '@shared/composables/use-dropdown';
import ButtonElement from '@shared/components/elements/button/button.element.vue';
import CheckboxElement from '@shared/components/elements/checkbox/checkbox.element.vue';

const props = withDefaults(defineProps<{
  modelValue: DropdownNs.DropdownOptionsItem[];
  title?: string;
  options: DropdownNs.DropdownOptionsItem[];
  name?: string;
  icon?: string;
  menuAlignment?: string;
  reset?: boolean;
  resetReverse?: boolean;
  arrow?: boolean;
  onlyIcon?: boolean;
}>(), {
  name: '',
  reset: true,
  resetReverse: false,
  arrow: true,
  onlyIcon: false,
});

const emit = defineEmits<{
  (e: 'change'): void;
  (e: 'update:modelValue', value: DropdownNs.DropdownOptionsItem[]): void;
}>();

const {isOpen, rootRef, toggle} = useDropdown();

function isSelected(option: DropdownNs.DropdownOptionsItem): boolean {
  return !!props.modelValue?.some(item => item.value === option.value);
}

function resetFilter(): void {
  if (props.resetReverse) {
    emit('update:modelValue', [...props.options]);
  } else {
    emit('update:modelValue', []);
  }
  emit('change');
}

function onOptionSelect(_event: Event, option: DropdownNs.DropdownOptionsItem): void {
  const selected = isSelected(option);
  const value = selected
    ? props.modelValue.filter(item => item.value !== option.value)
    : [...(props.modelValue || []), option];
  emit('update:modelValue', value);
  emit('change');
}
</script>

<style lang="scss" scoped>
.dropdown {
  width: 100%;
}

.dropdown-menu {
  width: 100%;
}

.dropdown-menu-head {
  display: flex;
  align-items: center;
  justify-content: flex-start;

  .title {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    width: 60%;
    font-weight: 500;
  }

  .button {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    width: 40%;
  }
}

.iconBox {
  width: 40px;
  display: flex;
  justify-content: center;
  align-items: center
}
</style>
